export const APPRAISAL_TEAM_LEAD = 0;
export const APPRAISAL_SPONSOR = 1;
export const APPRAISAL_TEAM_MEMBER = 2;
export const OBSERVER = 3;
export const REGISTERED_INTERPRETER = 4;
export const OU_COORDINATOR = 5;
